//mobile menu js file 

      // not working for this do change is line 1030 theme.js
//   $("#custom_body_class").click(function(){
//     $("body").toggleClass("changeCursor");
//   });
    
    

  $(document).ready(function() { 
      $('body').on('click', '.arrowback', function() {
  console.log("click");
$(this).parents(".custom-menus").parents(".cust_mega_maenu_main").removeClass("activewe");
});
    $("#flip").click(function(){
    $("#panel").slideToggle("slow");
  });
    
    
     $("#flip_scd").click(function(){
    $("#panel_scd").slideToggle("slow");
  });
    
      $("#flip_thrd").click(function(){
    $("#panel_thrd").slideToggle("slow");
  });
    
      $("#flip_frth").click(function(){
    $("#panel_frth").slideToggle("slow");
  });
     $("#flip_fth").click(function(){
    $("#panel_fth").slideToggle("slow");
  });
     $("#flip_sxt").click(function(){
    $("#panel_sxt").slideToggle("slow");
  });
    
$("#lrn_flp").click(function(){
    $("#lrn_pnl").slideToggle("slow");
  });
    
    $("#lrn_flpscd").click(function(){
    $("#lrn_pnlscd").slideToggle("slow");
  });
     $("#lrn_flpthrd").click(function(){
    $("#lrn_pnlthrd").slideToggle("slow");
  });
    
      
    $('.cus-menu-listss').click(function() {
    $(this).toggleClass('activewedfdf');
     
       console.log("second!");
      
}); 
    
     $('.heading_df').click(function() {
    $(this).toggleClass('activewedfdf');
     
       console.log("second!");
      
}); 
    
     
$('.cust_mega_maenu_main').click(function() {
 
    $(this).addClass('activewe');

}); 
   
$('.learn_more_li').click(function() {
    $(this).addClass('third');
});  

    
     $("#shop").click(function(){
    $(".cust_mega_maenu_main").addClass("activewedd");
  });
    
    

  });